/* USER COMPONENT *************************************************************/

// react redux
import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'
import i18n from 'i18next'

/* Utils */
import md5  from 'js-md5'

/* Actions */
import { setView } from 'react-redux/actions/app'
import * as VIEW from 'component/app/view'
import {
  logout
} from 'react-redux/actions/user'

/* Widgets */
import DropdownButton from 'widget/dropdown-button'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'

/* Styles */
import './user.css'

/**
* Main Application Header
*/
class User extends Component {

  getGravatarUrl() {
    const { email } = this.props
    if(!email) return null
    return 'https://www.gravatar.com/avatar/'+md5(
      email.trim().toLowerCase()
    )+"?d=identicon"
  }

  /* Logout api call */
  logout() {
    const { logout } = this.props
    logout()
  }

  setUserProfileView() {
    const { setView } = this.props
    setView(VIEW.USERPROFILE)
  }

  getFormattedName() {
      const { t, name, surname } = this.props
      let nameStr = ""
      if (name && surname) {
        nameStr = name + " " + surname
      } else if (name || surname){
        nameStr = name || surname
      }
      if (nameStr) {
        return (
          <div className="name">{ name + " " + surname }</div>
        )
      }
      return null
  }

  render() {
    const { api, t, email, name, surname, view } = this.props
    let buttonClassName = ["profile-button"]
    if (view === VIEW.USERPROFILE) buttonClassName.push("selected")
    return (
      <div className="user component">
        <a
          target="blank"
          href="https://gravatar.com"
          title={ t("user:gravatar.linkTitle") }
        >
            <img src={ this.getGravatarUrl() } width="80" height="80" />
        </a>
        { this.getFormattedName() }
        <div
          className="email"
          title={ t("user:emailAddressTitle")}
        >
          { email }
        </div>
        <div className="menu-wrapper">
          <button
            className={ buttonClassName.join(' ') }
            onClick={ this.setUserProfileView.bind(this) }
            title={ t("user:userProfileButtonTitle")}
          >
            <Icon
              icon={ ICON.SETTINGS }
              scheme={ICON_SCHEME.MENU}
              circle={ true }
              size={ 24 }
              interactive={ true }
            />
          </button>
          <button
            onClick={ this.logout.bind(this) }
             title={ t("user:logoutButtonTitle")}
           >
            <Icon
              icon={ ICON.LOGOUT }
              scheme={ICON_SCHEME.MENU}
              circle={ true }
              size={ 24 }
              interactive={ true }
            />
          </button>
        </div>
      </div>
    )
  }
}

User.propTypes = {}

function mapStateToProps(state) {
  return Object.assign(
    {},
    state.user,
    {
      view: state.app.view
    }
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setView
    },
    dispatch
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(User)
const translatedComponent = translate([], { withRef: true })(reduxComponent)
export default translatedComponent



// WEBPACK FOOTER //
// ./src/app/component/user/user.jsx